/* eslint no-console: 0 */
export default class Logger {
  // Info is used to emit descriptive messages about the application execution. No
  // action is expected by systems administrators or developers.
  static info(...args: any) {
    if (console && console.log && process.env.NODE_ENV !== 'test') {
      console.log.apply(console, [...args]);
    }
  }

  // Error signals an error occurred that should be logged, however the error is
  // not critical. The error may be transient by nature, but it should be logged
  // to help debug future problems via error message trending. For example, if a
  // connection to a remote server failed, but it will be retried automatically
  // and is fairly self-healing, it is not critical. But if it fails every night
  // at 2AM, you can look through the logs to find the trend.
  static error(...args: any) {
    if (console && console.warn && process.env.NODE_ENV !== 'test') {
      console.warn.apply(console, [...args]);
    }
  }

  // Critical indicates a serious error occurred during application execution.
  // Someone (systems administrators and/or developers) should be notified and
  // should take action to correct the issue.
  static crit(...args: any) {
    if (console && console.error && process.env.NODE_ENV !== 'test') {
      console.error.apply(console, [...args]);
    }
  }
}
